import { useState } from "react";
import MUIDataTableCustomStyle from "../Components/MUIDataTableCustomStyle";
import { Vocabulary } from "../Utils/Vocabulary";
import genericStyles from "../Styles/genericStyles.module.css";
import { ETableEditAction } from "../Utils/Enums";
import { TablesIds } from "../Utils/Constants";
import { endpoints } from "../Utils/UrlEnum";
import moment from "moment";

export default function DocumentValidity() {
  const [triggerReload, setTriggerReload] = useState(false);
  
  const userId = localStorage.getItem("userId");
  const dataUrl = userId 
    ? `${endpoints.instructor.user}/${userId}/documents/paginated`
    : "";

  const handleReload = () => {
    setTriggerReload(!triggerReload);
  };

  // Columns for combined documents table
  const documentsColumns = [
    {
      label: Vocabulary.documentName,
      name: "name",
      options: {
        sort: true,
      },
    },
    {
      label: Vocabulary.documentType,
      name: "type",
      options: {
        sort: true,
        customBodyRender: (value: string) => {
          return value === "vehicul" ? "Vehicul" : "Personal";
        },
      },
    },
    {
      label: Vocabulary.vehicle,
      name: "vehicleName",
      options: {
        sort: true,
        customBodyRender: (value: string | null) => {
          return value || "-";
        },
      },
    },
    {
      label: Vocabulary.expirationDocumentDate,
      name: "expirationDate",
      options: {
        sort: true,
        customBodyRender: (value: string) => {
          return value ? moment(value).format("DD.MM.YYYY") : "N/A";
        },
      },
    },
  ];

  return (
    <div className={genericStyles.mainContainer}>
      <MUIDataTableCustomStyle
        title={Vocabulary.documentValidity}
        columns={documentsColumns}
        onEditAction={ETableEditAction.NONE}
        id={TablesIds.DOCUMENT_VALIDITY_PERSONAL}
        CRUDEndPoint={dataUrl}
        hideAddButton={true}
        hideEditButton={true}
        hideDeleteButton={true}
        selectableRows="none"
        triggerReload={triggerReload}
        setTriggerReload={handleReload}
      />
    </div>
  );
}
